import { Axios } from "../../Api/axios";

// Gift revenue split v2 + wallet — backend: AdminRevenueController /
// AdminWalletController. Every analytics call takes an optional
// { from, to } (YYYY-MM-DD); without them the numbers are all-time.

const clean = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );

export const getRevenueSummary = (params) =>
  Axios.get("/Admin-revenue/summary", { params: clean(params) }).then((r) => r.data);

export const getRevenueUsers = (params) =>
  Axios.get("/Admin-revenue/users", { params: clean(params) }).then((r) => r.data);

export const getRevenueUser = (id, params) =>
  Axios.get(`/Admin-revenue/users/${id}`, { params: clean(params) }).then((r) => r.data);

export const getRevenueCategories = (params) =>
  Axios.get("/Admin-revenue/categories", { params: clean(params) }).then((r) => r.data);

export const getRevenueCategory = (id, params) =>
  Axios.get(`/Admin-revenue/categories/${id}`, { params: clean(params) }).then((r) => r.data);

export const getRevenueGifts = (params) =>
  Axios.get("/Admin-revenue/gifts", { params: clean(params) }).then((r) => r.data);

// Category goal / cycle length. The existing update endpoint validates
// `username` as required, so it is sent back unchanged.
export const updateCategoryCycle = (id, { username, cycle_goal_coins, cycle_months }) =>
  Axios.put(`/Admin-target-categories/${id}`, clean({ username, cycle_goal_coins, cycle_months })).then(
    (r) => r.data
  );

// ── Category run status (Start / Pause / Resume / Stop) ─────────────────
// A category shares gift revenue and counts toward its goal ONLY while it
// is running. Backend: AdminTargetCategories::run / runStatus / setDefault.
export const getCategoryRun = (id) =>
  Axios.get(`/Admin-target-categories/${id}/run`).then((r) => r.data.data);

export const categoryRunAction = (id, action, note) =>
  Axios.post(`/Admin-target-categories/${id}/run`, clean({ action, note })).then((r) => r.data.data);

export const setCategoryDefault = (id, isDefault) =>
  Axios.post(`/Admin-target-categories/${id}/default`, { is_default: isDefault ? 1 : 0 }).then((r) => r.data.data);

// ── Wallet ────────────────────────────────────────────────────────────────
export const walletSearch = (type, q) =>
  Axios.get("/Admin-wallet/search", { params: clean({ type, q }) }).then((r) => r.data);

export const walletOwner = (type, id, params) =>
  Axios.get(`/Admin-wallet/${type}/${id}`, { params: clean(params) }).then((r) => r.data);

export const walletAdjust = (body) => Axios.post("/Admin-wallet/adjust", body).then((r) => r.data);

export const walletTransactions = (params) =>
  Axios.get("/Admin-wallet/transactions", { params: clean(params) }).then((r) => r.data);

export const errorMessage = (e, fallback = "Something went wrong") =>
  e?.response?.data?.message ||
  (e?.response?.data?.errors && Object.values(e.response.data.errors).flat()[0]) ||
  fallback;
